import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class Modal {
  constructor(el) {
    this.dom = {el: el};
    this.dom.trigger = document.querySelectorAll('[data-js="job-modal-trigger"]');
    this.dom.closer = this.dom.el.querySelectorAll('[data-js="job-modal-closer"]');

    this.dom.slider = this.dom.el.querySelector('.splide');
    this.dom.slides = null;

    this.slug = null;
    this.target = null;
    this.isShow = false;
    this.job = null;

    this.toggleModal = this.toggleModal.bind(this); 

    this.slider = null;
    this.option = {
      autoplay: false,
      type: 'fade',
      perPage: 1,
      autoHeight: true,
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      speed: 900,
      arrows: false,
      pagination: false,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          arrows: true,
        }
      }
    };

    this.init();
  }

  init() {
    [...this.dom.trigger].forEach(el => {
      el.addEventListener('click', this.toggleModal);
    });
    [...this.dom.closer].forEach(el => {
      el.addEventListener('click', this.toggleModal);
    });

    this.slider = new Splide(this.dom.slider, this.option);
    
  }

  toggleModal(e) {
    // this.dom.slides = Array.from(this.dom.el.querySelectorAll('.splide__slide'));
    if (!this.isShow) {
      this.slider.mount();
      this.dom.el.dataset.is = 'show'
      // this.job = e.currentTarget.dataset.job;
      // const index = this.dom.slides.findIndex(slide => slide.dataset.job === this.job);
      const index = Number(e.currentTarget.dataset.index);
      this.slider.go(index)
      this.isShow = true;
    } else {
      this.dom.el.removeAttribute('data-is')
      this.isShow = false;
      this.slider.destroy();
    }
  }
}

export default Modal